import {
  Button,
  Popconfirm,
  Popover,
  Space,
  Table,
  Tooltip,
  Typography,
  notification,
} from "antd";
import { useEffect, useState } from "react";
import useApi from "../../utils/useApi";
import { describeError, formatDateTime } from "./status";

const { Text } = Typography;
const ACOES = { excluida: "Excluída", restaurada: "Restaurada" };

export function HistoricoDaRotina({ historico }) {
  if (!historico?.length) return null;
  return (
    <Popover
      title="Histórico"
      trigger="click"
      content={
        <div style={{ maxWidth: 360 }}>
          {historico.map((evento) => (
            <div
              key={`${evento.acao}-${evento.em}`}
              style={{ marginBottom: 6 }}>
              <Text strong>{ACOES[evento.acao] || evento.acao}</Text>{" "}
              <Text>em {formatDateTime(evento.em)}</Text>
              <Text type="secondary" style={{ display: "block" }}>
                por {evento.por || "usuário removido"}
              </Text>
            </div>
          ))}
        </div>
      }>
      <Button type="link" size="small">
        Histórico
      </Button>
    </Popover>
  );
}

export default function RotinasExcluidas({ filiais, onRestaurada }) {
  const { getAiReportRoutines, restoreAiReportRoutine } = useApi();
  const [rotinas, setRotinas] = useState([]);
  const [carregando, setCarregando] = useState(false);

  const carregar = async () => {
    setCarregando(true);
    try {
      const dados = await getAiReportRoutines({ excluidas: true });
      setRotinas(Array.isArray(dados) ? dados : []);
    } catch (err) {
      notification.error({
        message: "Erro ao carregar as rotinas excluídas.",
        description: describeError(err, ""),
      });
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    carregar();
  }, []);

  const restaurar = async (rotina) => {
    try {
      await restoreAiReportRoutine(rotina.id);
      notification.success({
        message: `Rotina ${rotina.name} restaurada.`,
        description:
          "Ela voltou inativa. Ative na edição quando quiser que envie.",
      });
      await carregar();
      if (onRestaurada) onRestaurada();
    } catch (err) {
      notification.error({
        message: "Erro ao restaurar.",
        description: describeError(err, ""),
      });
    }
  };

  const colunas = [
    {
      title: "Rotina",
      dataIndex: "name",
      key: "name",
      render: (v) => <Text strong>{v}</Text>,
    },
    { title: "Cliente", dataIndex: "client_name", key: "client" },
    {
      title: "Filiais",
      dataIndex: "branches",
      key: "branches",
      render: (ids) =>
        ids && ids.length ? (
          ids.map((id) => filiais[id] || id).join(", ")
        ) : (
          <Text type="danger">nenhuma filial</Text>
        ),
    },
    {
      title: "Prompt",
      key: "prompt",
      ellipsis: { showTitle: false },
      render: (_, r) =>
        r.pedido ? (
          <Tooltip title={r.pedido}>
            <span>{r.pedido}</span>
          </Tooltip>
        ) : (
          r.prompt_template_slug
        ),
    },
    {
      title: "Excluída",
      key: "excluida",
      render: (_, r) => (
        <span>
          {formatDateTime(r.excluida_em)}
          <Text type="secondary" style={{ display: "block" }}>
            por {r.excluida_por || "usuário removido"}
          </Text>
        </span>
      ),
    },
    {
      title: "Ações",
      key: "actions",
      width: 200,
      render: (_, r) => (
        <Space size="small" wrap>
          <HistoricoDaRotina historico={r.historico} />
          <Popconfirm
            title="Restaurar rotina?"
            description="Ela volta para a lista inativa e só envia depois de ativada."
            onConfirm={() => restaurar(r)}
            okText="Restaurar"
            cancelText="Cancelar">
            <Button type="link" size="small">
              Restaurar
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table
      dataSource={rotinas}
      columns={colunas}
      rowKey="id"
      loading={carregando}
      pagination={false}
      size="middle"
      locale={{ emptyText: "Nenhuma rotina excluída." }}
    />
  );
}
